import { Alert, Tabs } from "antd-v5";
import React, { useMemo } from "react";
import { CellRenderers } from "utils/tableUtils";
import PageComingSoon from "views/Pages/PageComingSoon";

import { GenericIntegrationView, TabConfig } from "../GenericIntegration";
import GoogleWorkspaceConfigForm from "./GoogleWorkspaceConfigForm";
import GoogleWorkspaceFileUpload from "./GoogleWorkspaceFileUpload";
import {
  GOOGLE_WORKSPACE_INTEGRATION_TYPE,
  GoogleWorkspaceConfig,
} from "./googleWorkspaceConstants";

interface GoogleWorkspaceViewProps {
  onUpdateConfigComponent?: () => void;
  name?: string;
  [key: string]: unknown;
}

const googleWorkspaceCustomColumns = [
  {
    title: "Admin Email",
    dataIndex: ["authConfig", "impersonationEmail"],
    render: (v: string) => CellRenderers.VALUE_OR_NA(v),
  },
  {
    title: "Products",
    dataIndex: ["configProperties", "aiemGwsProducts"],
    render: (v: string[]) =>
      Array.isArray(v) && v.length > 0 ? v.join(", ") : "N/A",
  },
];

function LocalAgentTab() {
  return (
    <>
      <Alert
        type="info"
        className="m-b-md"
        message="The Local Agent is a lightweight Docker container that runs within your infrastructure to ensure sensitive raw data never leaves your network. It extracts and processes data locally, transmitting only the summaries required for security assessment."
      />
      <PageComingSoon />
    </>
  );
}

export default function GoogleWorkspaceView({
  onUpdateConfigComponent,
  name,
  ...rest
}: GoogleWorkspaceViewProps) {
  const configTabs: TabConfig[] = useMemo(
    () => [
      {
        key: "google_workspace",
        label: "Google Workspace",
        integrationType: GOOGLE_WORKSPACE_INTEGRATION_TYPE,
        customColumns: googleWorkspaceCustomColumns,
        showTriggerScan: true,
      },
    ],
    [],
  );

  return (
    <Tabs
      defaultActiveKey="config"
      items={[
        {
          key: "config",
          label: "Cloud Connector",
          children: (
            <GenericIntegrationView<GoogleWorkspaceConfig>
              tabs={configTabs}
              FormComponent={GoogleWorkspaceConfigForm}
              onUpdateConfigComponent={onUpdateConfigComponent}
              addButtonText="Add Configuration"
              name={name}
              {...rest}
            />
          ),
        },
        {
          key: "file_upload",
          label: "Upload File",
          children: <GoogleWorkspaceFileUpload />,
        },
        {
          key: "self_hosting",
          label: "Local Agent",
          children: <LocalAgentTab />,
        },
      ]}
    />
  );
}
